import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { withModalActions } from 'core/hocs';
import { FormattedTag } from 'core/components';
import { MODAL_IDS } from 'src/constants';

import './promo-registration-notification.scss';

class PromoRegistrationNotificationUI extends Component {
  static propTypes = {
    openModalAndCloseOthers: PropTypes.func.isRequired,
  };

  onButtonClick = () => {
    const { openModalAndCloseOthers } = this.props;

    openModalAndCloseOthers(MODAL_IDS.SIGN_UP);
  };

  render() {
    return (
      <div className="promo-registration-notification d-flex align-items-center p-1_5 bg-dark-2 rounded border border-primary">
        <img
          src="/assets/public/images/registration-promo.png"
          className="mr-2"
          alt="registration-promo"
          width={56}
          height={56}
        />

        <FormattedTag
          tag="div"
          id="promo-registration-notification.title"
          className="promo-registration-notification-title font-weight-semi-bold mr-2"
        />

        <FormattedTag
          id="promo-registration-notification.button"
          tag={Button}
          color="primary"
          className="promo-registration-notification-btn text-center py-1 px-1_25 w-100"
          onClick={this.onButtonClick}
        />
      </div>
    );
  }
}

export const PromoRegistrationNotification = withModalActions(PromoRegistrationNotificationUI);
